var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _vm.showEdit
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-circle-plus-outline"
                  },
                  on: { click: _vm.handleCreate }
                },
                [_vm._v(_vm._s(_vm.$t("button.add")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "element-loading-text": "数据正在加载中...",
            border: "",
            stripe: "",
            fit: "",
            "highlight-current-row": ""
          },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: _vm.$t("table.id"), width: "50" }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "场次名称",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.itemName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "每个用户可报名人数（人）",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.maxRegNum))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "所属剧院",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.theaterName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.actions"),
              "class-name": "small-padding fixed-width",
              "min-width": "160px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.showEdit
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              plain: "",
                              icon: "el-icon-edit"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleUpdate(scope.row.id)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.edit")))]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "mini",
                          plain: "",
                          icon: "el-icon-setting"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleSetPrcie(scope.row)
                          }
                        }
                      },
                      [_vm._v("区域价格设置")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "mini",
                          plain: "",
                          icon: "el-icon-setting"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleSeat(scope.row)
                          }
                        }
                      },
                      [_vm._v("座位设置")]
                    ),
                    _vm.showEdit
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              size: "mini",
                              plain: "",
                              icon: "el-icon-delete"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleDelete(scope.row.id)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.delete")))]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.listQuery.page,
              "page-sizes": [10, 20, 30, 50],
              "page-size": _vm.listQuery.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c("addConfig", {
            attrs: {
              activityManageId: _vm.keyValue,
              "key-value": _vm.Id,
              "show-dialog": _vm.dialogFormVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogPriceVisible,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogPriceVisible = $event
            }
          }
        },
        [
          _c("priceList", {
            attrs: {
              activityAuditStatus: _vm.activityAuditStatus,
              theaterId: _vm.theaterId,
              "key-value": _vm.Id,
              "show-dialog": _vm.dialogPriceVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogSeatVisible,
            width: "1400px",
            top: "0vh"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogSeatVisible = $event
            }
          }
        },
        [
          _vm.dialogSeatVisible
            ? _c("seat", {
                attrs: {
                  activityAuditStatus: _vm.activityAuditStatus,
                  theaterId: _vm.theaterId,
                  "key-value": _vm.Id,
                  "show-dialog": _vm.dialogSeatVisible
                },
                on: { handCancle: _vm.handCancle }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }